import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DashboardPartsInventoryTabDetails } from "./TabDetails";
import {
    Button,
    Tabs,
    Typography,
    Avatar,
    Chip,
    IconButton,
    Popover,
    Dialog,
    Spinner,
} from "@material-tailwind/react";
import { MoreHoriz, Database } from "iconoir-react";

import { getPartStatusColor } from "../../../../utils/formatViews";
import { RootState } from "../../../../redux";
import { getPartRequest } from "../../../../redux/parts/actions";
import AppImages from "../../../../assets/AppImages";

const DETAILS_HEAD = [
    {
        comp: DashboardPartsInventoryTabDetails,
        v: "details",
        n: "Details",
        i: AppImages.iconClipboardCheck,
    },
    {
        comp: null,
        v: "stock",
        n: "Stock",
        i: Database,
        disabled: true,
    },
    {
        comp: null,
        v: "media",
        n: "Media",
        i: AppImages.iconPhotograph,
        disabled: true,
    },
];

export function DashboardPartsInventoryDetails() {
    const dispatch = useDispatch();
    const id = useParams().id;
    const navigate = useNavigate();
    const { part, loading } = useSelector((state: RootState) => state.parts);
    const [activeTab, setActiveTab] = React.useState<string>("details");

    React.useEffect(() => {
        dispatch(
            getPartRequest({
                id: Number(id),
                part_fields: "",
            })
        );
    }, [dispatch, id]);

    React.useEffect(() => {
        if (part?.id == -1) {
            navigate("/dashboard/parts/inventory");
        }
    }, [part]);

    return (
        <React.Fragment>
            <Dialog open={loading}>
                <Dialog.Overlay>
                    <div className="flex flex-col justify-center items-center h-full">
                        <Spinner size="xxl" />
                    </div>
                </Dialog.Overlay>
            </Dialog>
            <div className="flex mt-5 justify-between items-center">
                <div className="flex gap-x-5 items-center relative">
                    <Button
                        color="secondary"
                        className="bg-white px-3 py-3 text-primary"
                        onClick={() => {
                            try {
                                navigate(-1);
                            } catch {
                                navigate('/dashboard/parts/inventory');
                            }
                        }}
                    >
                        <AppImages.iconArrowLeft className="h-3 w-3" />
                    </Button>

                    <div className="items-center flex gap-x-3">
                        {part?.thumbnail?.full_url && (
                            <Avatar
                                src={part?.thumbnail.full_url}
                                alt={part?.name}
                                shape="rounded"
                            />
                        )}
                        <div className="flex flex-col gap-x-3">
                            <Typography
                                type="small"
                                color="default"
                                className="text-lg font-bold text-primary"
                            >
                                {part?.name}
                            </Typography>
                            <Typography type="small" color="default" className="text-foreground">
                                {part?.number}
                            </Typography>
                        </div>
                        {part?.status && (
                            <Chip
                                size="sm"
                                isPill={false}
                                className="w-max"
                                color={getPartStatusColor(part.status)}
                            >
                                <Chip.Label className="capitalize text-white font-bold">
                                    {part.display_status}
                                </Chip.Label>
                            </Chip>
                        )}
                    </div>
                </div>
                <Popover placement="bottom-end">
                    <Popover.Trigger
                        as={IconButton}
                        variant="outline"
                        color="secondary"
                        className="h-5 bg-white"
                    >
                        <MoreHoriz className="w-4 h-4" />
                    </Popover.Trigger>
                    <Popover.Content className="-mt-1">
                        <Button
                            variant="outline"
                            color="error"
                            className="h-8 flex items-center !py-1 gap-2 sm:w-auto w-full"
                        >
                            Delete
                            <AppImages.iconTrash className="w-4 h-4" />
                        </Button>
                    </Popover.Content>
                </Popover>
            </div>
            <Tabs
                defaultValue="details"
                value={activeTab}
                className="mt-5"
                onValueChange={setActiveTab}
            >
                <Tabs.List className="w-max max-w-full overflow-x-auto">
                    {DETAILS_HEAD.map((el, idx) => (
                        <Tabs.Trigger
                            key={idx}
                            className={`w-max px-4 py-2
                                ${ el.v === activeTab ? "text-primary" : "text-[#64748B]"}
                                ${el?.disabled ? "text-[#64748B] cursor-not-allowed" : ""}
                            `}
                            value={el.v}
                            disabled={el?.disabled}
                        >
                            <el.i className="mr-2 h-4 w-4" />
                            <span className="text-nowrap">{el.n}</span>
                        </Tabs.Trigger>
                    ))}
                    <Tabs.TriggerIndicator />
                </Tabs.List>
                {DETAILS_HEAD.map((el, idx) => (
                    <Tabs.Panel key={idx} value={el.v}>
                        {el.comp && <el.comp />}
                    </Tabs.Panel>
                ))}
            </Tabs>
        </React.Fragment>
    );
}
